
import { Box, Typography, useTheme, useMediaQuery, List, ListItem, Link } from "@mui/material";
import './advice.css';
//import { useNavigate } from "react-router-dom";

function Advice() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(700));
  const widthText = isMobile ? "90%" : "70%";
  //const navigate = useNavigate();

  return (
    <Box className="advice-container" >
      <Box className="advice-content" sx={{
        maxWidth: widthText, // limita el ancho
        mx: "auto",         // centra horizontalmente
        px: 2,
        py: 4,
      }}>
        <Typography className="title"
          sx={{
            color: "#E66671",
            fontWeight: "bold",
            textAlign: "center",
            fontFamily: "BloodOrange, sans-serif"
          }}
        >
          ✧ Política de Privacidad ✧
        </Typography>
        <Typography
          className="company-text"
          variant="body1"
          sx={{ mt: 4 }}
        >
          En cumplimiento a lo dispuesto por la Ley Federal de Protección de Datos Personales en Posesión de Particulares, hacemos de su conocimiento lo siguiente:
        </Typography>
        <Typography className="company-text" variant="body1" sx={{ mt: 2 }}>
          Marián® con domicilio fiscal en Vía Morelos 268, Santa María Tulpetlac, Ecatepec de Morelos, 55400, Estado de México, México y dirección web{" "}
          <Link href="https://www.marian.com.mx" target="_blank" rel="noopener noreferrer">
            https://www.marian.com.mx
          </Link>, es el responsable del uso y protección de sus datos personales, por lo que le informamos lo siguiente:
        </Typography>
        <Typography
          className="company-text"
          variant="body1"
          sx={{ mt: 2, }}
        >
          Los datos personales que recabamos, los utilizaremos para las siguientes finalidades primarias:
        </Typography>
        <List sx={{ listStyleType: "disc", pl: 4 }}>
          <ListItem sx={{ display: "list-item" }}>Contar con sus datos de contacto</ListItem>
          <ListItem sx={{ display: "list-item" }}>Adquirir y monitorear publicidad inteligente</ListItem>
        </List>
        <Typography
          className="company-text"
          variant="body1"
          sx={{ mt: 2, }}
        >
          Para llevar a cabo las finalidades descritas en el presente aviso de privacidad, utilizaremos los siguientes datos personales:
        </Typography>
        <List sx={{ listStyleType: "disc", pl: 4 }}>
          <ListItem sx={{ display: "list-item" }}>Datos de identificación y contacto.</ListItem>
        </List>
        <Typography className="company-text" variant="body1" sx={{ mt: 2 }}>
          Sus datos personales son recabados a través de nuestras redes sociales, plataformas para concursos o promociones y la navegación en nuestros portales, utilizando píxeles de seguimiento y cookies. Adicionalmente recabamos sus datos de identificación y contacto en caso de que usted nos los proporcione en la sección “Contáctanos” de nuestro sitio web{" "}
          <Link href="https://www.marian.com.mx" target="_blank" rel="noopener noreferrer">
            https://www.marian.com.mx
          </Link>.
        </Typography>
        <Typography
          className="company-text"
          variant="body1"
          sx={{ mt: 2, }}
        >
          En caso de requerirse, compartiremos sus datos personales como se enlista a continuación:
        </Typography>
        <List sx={{ listStyleType: "disc", pl: 4 }}>
          <ListItem sx={{ display: "list-item" }}>Empresa responsable de gestionar nuestras campañas publicitarias y concursos.</ListItem>
          <ListItem sx={{ display: "list-item" }}>Empresa responsable de la gestión de nuestro portal web.</ListItem>
          <ListItem sx={{ display: "list-item" }}>Empresas generadoras de publicidad.</ListItem>
        </List>
        <Typography
          className="company-text"
          variant="body1"
          sx={{ mt: 2, }}
        >
          Los datos que transferimos de usted podrán ser algunos o todos de los mencionados en el siguiente listado:
        </Typography>
        <List sx={{ listStyleType: "disc", pl: 4 }}>
          <ListItem sx={{ display: "list-item" }}>Datos de identificación y contacto.</ListItem>
          <ListItem sx={{ display: "list-item" }}>Tipo dispositivo y dirección.</ListItem>
        </List>
        <Typography
          className="company-text"
          variant="body1"
          sx={{ mt: 2, }}
        >
          <b>Ejercicio de Derechos ARCO</b><br /><br />
          Usted tiene derecho a conocer qué datos personales tenemos de usted, para que los utilizamos y las condiciones del uso que les damos (acceso). Así mismo, es su derecho solicitar la corrección de su información personal en caso de que esté desactualizada, sea inexacta o incompleta (rectificación); que la eliminemos de nuestros registros o bases de datos cuando considere que la misma no está siendo utilizada adecuadamente (cancelación); así como oponerse al uso de sus datos personales para fines específicos (oposición).

        </Typography>
        <Typography
          className="company-text"
          variant="body1"
          sx={{ mt: 2, }}
        >
          Usted puede revocar el consentimiento que, en su caso, nos haya otorgado para el tratamiento de sus datos personales. Sin embargo, es importante que tenga en cuenta que no en todos los casos podremos atender su solicitud o concluir el uso de forma inmediata, ya que es posible que por alguna obligación legal requiramos seguir tratando sus datos personales. Asimismo, usted deberá considerar que, para ciertos fines, la revocación de su consentimiento implicara que no le podamos seguir prestando el servicio que nos solicitó, o la conclusión de su relación con nosotros.
        </Typography>
        <Typography
          className="company-text"
          variant="body1"
          sx={{ mt: 2, }}
        >
          Para el ejercicio de derechos ARCO (acceso, rectificación, cancelación y oposición), usted deberá presentar la solicitud respectiva a través del siguiente medio: privacidad@lacostena.com.mx, donde se le dará a conocer el procedimiento respectivo, si lo prefiere puede acudir de manera presencial al domicilio indicado al inicio de este aviso de privacidad, dirigiéndose al departamento de Recursos Humanos.
        </Typography>
        <Typography
          className="company-text"
          variant="body1"
          sx={{ mt: 2, mb: 4 }}
        >
          El presente aviso de privacidad puede sufrir modificaciones sin previo aviso, derivadas de nuevos requerimientos legales, de nuestras propias necesidades, por los productos o servicios que ofrecemos, de nuestras prácticas de privacidad, de cambios en nuestro modelo de negocio o por otras causas. Los cambios que pueda sufrir el presente aviso de privacidad los puede consultar en nuestra página web{" "}
          <Link href="https://www.marian.com.mx" target="_blank" rel="noopener noreferrer">
            https://www.marian.com.mx
          </Link>
        </Typography>
      </Box>

    </Box>
  );
}

export default Advice;